<ng-container *ngIf="vm$ | async as vm">
	<ng-container *ngIf="vm.showSideNav; else no_side_nav">
		<div
			class="min-h-0 h-full bg-green-950 flex flex-col z-[901] relative max-h-screen"
			data-intercom-target="global-navbar"
		>
			<div class="p-3 pb-4 border-b border-white/10">
				<div class="mb-4">
					<a
						class="inline-block cursor-pointer"
						[ngClass]="{
							'-mx-2 -mb-3 -mt-1': vm.specialOccasionLogoUrl,
							'w-12 h-12 m-2': !vm.specialOccasionLogoUrl,
						}"
						(click)="goHome()"
						[testHook]="testHooks.HomeLink"
					>
						<img
							*ngIf="vm.specialOccasionLogoUrl; else standardLogo"
							[src]="vm.specialOccasionLogoUrl"
						/>
						<ng-template #standardLogo>
							<img src="/assets/images/closer-icon-white.svg" />
						</ng-template>
					</a>
				</div>
				<button
					class="flex h-12 w-16 flex-col items-center justify-center rounded-md bg-green-600 text-white duration-300 hover:bg-green-800 active:ring-2 active:ring-green-400"
					(click)="addFile()"
					data-intercom-target="add-file"
					[testHook]="testHooks.AddFileButton"
				>
					<i-tabler name="plus" size="16" />
					<span class="text-[10px] leading-[16px] text-white/80">New File</span>
				</button>
			</div>
			<div class="flex-1 flex flex-col overflow-y-scroll no-scrollbar">
				<ui-menu
					[items]="vm.mainMenu.items"
					[testHook]="testHooks.MainMenu"
					[theme]="THEMES.DARK"
					size="lg"
				></ui-menu>
				<div class="border-t border-white/10 mt-4">
					<ui-menu
						[title]="vm.inboxMenu.title"
						[items]="vm.inboxMenu.items"
						[testHook]="testHooks.InboxMenu"
						[theme]="THEMES.DARK"
						size="lg"
					></ui-menu>
				</div>
			</div>
			<div class="border-t border-white/10 shadow-lg pb-4">
				<ui-menu
					[items]="vm.settingsMenu.items"
					[testHook]="testHooks.SettingsMenu"
					[theme]="THEMES.DARK"
					size="lg"
				></ui-menu>
			</div>
		</div>

		<div
			*ngIf="vm.flyoutState"
			class="fixed inset-0 z-[850] bg-black/40 duration-300"
			[ngClass]="{
				'opacity-100': vm.flyoutState,
				'opacity-0': !vm.flyoutState,
			}"
			(click)="closeSideNav()"
			[testHook]="testHooks.CloseSideNavDiv"
		></div>
		<div
			class="w-96 min-h-0 h-full bg-white rounded-r-2xl fixed top-0 z-[900] left-[88px] shadow-2xl p-6 duration-300 overflow-y-scroll"
			[ngClass]="{
				'-translate-x-full': !vm.flyoutState,
			}"
			*ngIf="vm.flyoutState"
		>
			<ui-content-header
				[title]="vm.flyoutState | capitalize"
				[testHook]="testHooks.ContentHeader"
			>
				<ui-button
					actions
					icon="x"
					(click)="closeSideNav()"
					[preset]="preset.ICON_DEFAULT"
					[testHook]="testHooks.CloseSideNavButton"
				/>
			</ui-content-header>
			<div [ngSwitch]="vm.flyoutState">
				<app-global-search
					*ngSwitchCase="SideNavFlyoutType.SEARCH"
					(onClose)="closeSideNav()"
				></app-global-search>

				<app-appointments
					*ngSwitchCase="SideNavFlyoutType.APPOINTMENTS"
					(onClose)="closeSideNav()"
				></app-appointments>

				<app-support
					*ngSwitchCase="SideNavFlyoutType.SUPPORT"
					(onClose)="closeSideNav()"
				></app-support>
			</div>
		</div>
	</ng-container>
	<ng-template #no_side_nav>
		<div></div>
	</ng-template>
</ng-container>
